import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';
import { GeneralService } from '../../general.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-question-menu',
  templateUrl: './question-menu.component.html',
  styleUrls: ['./question-menu.component.scss']
})
export class QuestionMenuComponent implements OnInit {

  public expandMenu = this.dataSvc.expandMenu;
  

  
  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService,
    public translate: TranslateService
  ) {
    if(dataSvc != null && dataSvc !== undefined){
      var usersLanguage = dataSvc.currentUser.Language.DotNetCulture.toString().substring(0,2);
      if(usersLanguage != null){
        translate.setDefaultLang(usersLanguage);
        translate.use(usersLanguage);
      }
      else{
        translate.setDefaultLang('en');
        translate.use('en');
      }
    }
    else{
      translate.setDefaultLang('en');
      translate.use('en');
    }
   }

  ngOnInit() {
  }

}
